// extracted by mini-css-extract-plugin
export var divider = "_e6-7";
export var itemsToggle = "_e6-8";
export var mergeModal = "_e6-1";
export var optionCard = "_e6-4";
export var radioGroup = "_e6-6";
export var radioOption = "_e6-0";
export var selected = "_e6-5";
export var shipmentOptions = "_e6-2";
export var tableOptions = "_e6-3";